import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import { qualificationActions as actions, notificationActions } from '../actions';
import { qualificationService } from '../services';

/* Add qualification Sagas*/
function* handleAddQualificationRequest() {
    const action = yield take(actions.addQualificationRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(qualificationService.addQualification, dataParams);
        if (res.isError) {
            yield put(actions.addQualificationError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addQualificationSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addQualificationError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get qualification Sagas*/
function* handleGetAllQualificationRequest() {
    const action = yield take(actions.getAllQualificationRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(qualificationService.getAllQualification, dataParams);

        if (res.isError) {
            yield put(actions.getAllQualificationError(res));

        } else {
            yield put(actions.getAllQualificationSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllQualificationError());
    }
}

/* Get Qualification By Parent Id Sagas*/
function* handleGetAllQualificationsByParentIdRequest() {
    const action = yield take(actions.getAllQualificationsByParentIdRequest.getType());
    const dataParams = action.payload;
    let res;
    try {

        res = yield call(qualificationService.getAllQualificationsByParentId, dataParams);
        if (res.isError) {
            yield put(actions.getAllQualificationsByParentIdError(res));
        } else {
            yield put(actions.getAllQualificationsByParentIdSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllQualificationsByParentIdError());
    }
}

/* Update Qualification Sagas*/
function* handleUpdateQualificationRequest() {
    const action = yield take(actions.updateQualificationRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(qualificationService.updateQualification, dataParams);
        if (res.isError) {
            yield put(actions.updateQualificationError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

        } else {
            yield put(actions.updateQualificationSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }

    } catch (error) {
        yield put(actions.updateQualificationError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Delete Qualification Sagas*/
function* handleDeleteQualificationRequest() {
    const action = yield take(actions.deleteQualificationRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(qualificationService.deleteQualification, dataParams);
        if (res.isError) {
            yield put(actions.deleteQualificationError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteQualificationSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }

    } catch (error) {
        yield put(actions.deleteQualificationError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}


/* -----------Watchers------------- */
function* handleAddQualificationWatcher() {
    yield takeEvery(
        actions.addQualificationRequest,
        handleAddQualificationRequest,
    );
}

function* handleGetQualificationWatcher() {
    yield takeEvery(
        actions.getAllQualificationRequest,
        handleGetAllQualificationRequest,
    );
}

function* handleGetAllQualificationsByParentIdWatcher() {
    yield takeEvery(
        actions.getAllQualificationsByParentIdRequest,
        handleGetAllQualificationsByParentIdRequest,
    );
}

function* handleUpdateQualificationWatcher() {
    yield takeEvery(
        actions.updateQualificationRequest,
        handleUpdateQualificationRequest,
    );
}

function* handleDeleteQualificationWatcher() {
    yield takeEvery(
        actions.deleteQualificationRequest,
        handleDeleteQualificationRequest,
    );
}


function* rootQualificationSaga() {
    yield all([
        handleAddQualificationRequest(),
        handleAddQualificationWatcher(),

        handleGetAllQualificationRequest(),
        handleGetQualificationWatcher(),

        handleGetAllQualificationsByParentIdRequest(),
        handleGetAllQualificationsByParentIdWatcher(),

        handleUpdateQualificationRequest(),
        handleUpdateQualificationWatcher(),

        handleDeleteQualificationRequest(),
        handleDeleteQualificationWatcher(),

    ]);
}

export default rootQualificationSaga;
